import React from 'react'
import styled from 'styled-components'
import { CardHeader } from 'components'
import { PosterSorting } from 'generated/graphql'
import { _ } from 'utils'
import FileUpload, { IMAGE_ONLY } from '../../forms/components/FileUpload'
import SelectField from '../../forms/components/SelectField'
import Switch from '../../forms/components/Switch'
import TextField from '../../forms/components/TextField'

const S = {
    SettingHeader: styled(CardHeader)`
        margin: 0 0 10px 10px;
    `,
    Switch: styled(Switch)`
        margin-bottom: 20px;
    `,
}

const Settings = () => (
    <>
        <S.SettingHeader>
            {_('poster.form.setting_header')}
        </S.SettingHeader>
        <TextField
            label={_('poster.form.name')}
            name="parent.name"
            lg={1/2}
        />
        <FileUpload
            name="parent.image"
            label={_('poster.form.image')}
            accept={IMAGE_ONLY}
            lg={1/2}
        />
        <SelectField
            label={_('poster.form.sort_order')}
            name="posterSorting"
            options={[
                { label: _('poster.form.sort_by.title'), value: PosterSorting.Title },
                { label: _('poster.form.sort_by.author_name'), value: PosterSorting.Author },
            ]}
            isClearable={false}
            helperText={_('poster.form.sort_by.helper_text')}
            lg={1/2}
        />

        <S.Switch
            label={_('poster.form.video_chat')}
            name="enableVideo"
        />
        <S.Switch
            label={_('poster.form.messaging')}
            name="enableMessaging"
        />
        <S.Switch
            label={_('poster.form.public_chat')}
            name="parent.enableChat"
        />

    </>
)

export default Settings
